import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import ClipboardImageHandler from '../common/form/ClipboardImageHandler'

import {
	setModoTela, initForm
} from './startupActions';

class StartupForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir || this.props.visualizacao ? 'readOnly' : '';

		
		return (
			<Row alignCenter>
				<Grid cols='12 10 8 5'>
					<ContentCard style={{ backgroundColor: '#63c8c3' }}>
						<Form event={this.props.handleSubmit}>
							<ContentCardBody>
								<Row>
									<Field
										name='nome'
										component={LabelAndInput}
										label='Nome: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />

									<Field
										name='link'
										component={LabelAndInput}
										label='Link (site): *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />


									{!readOnly &&
									<Grid cols='12 12 12 12'
										style={{
											marginBottom: 12
										}}>

										<p>Logo (quadrada): *</p>

										{this.props.formularioValues.imagem && 
										<img 
											style={{
												width: 100,
												height: 100,
												marginBottom: 12,
												backgroundColor: '#ffffff',
												padding: 8
											}}
											src={this.props.formularioValues.imagem}>
										</img>}
										
										<ClipboardImageHandler
											label='Use Ctrl+V para colar ou arraste e solte anexos aqui.'
											msgErro='Selecione apenas (.PNG, .JPG e .JPEG)'
											types={[
												'image/png',
												'image/jpg',
												'image/jpeg'
											]}
											onChange={result => {
												this.props.initForm({
													...this.props.formularioValues,
													imagem: result
												});
											}} />
									</Grid>}

								</Row>

								<Row alignCenter>
									{!this.props.visualizacao &&
									<Grid cols='8 8 8 8'>
										{this.props.excluir ? (
											<Button
												text='Excluir'
												submit type={'danger'}
												icon={'fa fa-trash'} />
										) : (
										<Button
											text='Salvar'
											submit
											type={'success'}
											icon={'fa fa-check'} />
										)}
									</Grid>}
									<Grid cols='4 4 4 4'>
										<Button
											text='Voltar'
											type={'success'}
											icon={'fa fa-chevron-left'}
											event={() => window.confirm('Deseja realmente sair dessa tela?') ? this.props.setModoTela('lista') : null} />
									</Grid>
								</Row>
							</ContentCardBody>
						</Form>
					</ContentCard>
				</Grid>
			</Row>
		);
    }


}

StartupForm = reduxForm({form: 'startupForm', destroyOnUnmount: false})(StartupForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('startupForm')(state),
	registro: state.startup.registro,
	lista: state.startup.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(StartupForm);
